/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M4.5 1.5v2.25h18.75c-.0005 0 .0005 0 0 0 .4135.0008.75.3363.75.75a.7502.7502 0 0 1-.6152.738l-.1348.012H4.5V7.5c0-.0005 0 .0005 0 0-.0008.4135-.3363.75-.75.75a.7502.7502 0 0 1-.738-.6152L3 7.5V5.25H.75c.0005 0-.0005 0 0 0C.3365 5.2492 0 4.9137 0 4.5a.7502.7502 0 0 1 .6152-.738L.75 3.75H3V1.5c0 .0005 0-.0005 0 0 .0008-.4136.3363-.75.75-.75a.7502.7502 0 0 1 .738.6152L4.5 1.5Zm16.4879 14.8652a.7502.7502 0 0 0-1.4879.1334c0 .0004 0-.0005 0 0V18.75H.75l-.1348.0121A.7502.7502 0 0 0 .7486 20.25c.0004 0-.0005 0 0 0H19.5v2.25l.0121.1348A.7502.7502 0 0 0 21 22.5015c0-.0005 0 .0004 0 0V20.25h2.25l.1348-.0121a.7502.7502 0 0 0-.1334-1.4879c-.0004 0 .0005 0 0 0H21V16.5l-.0121-.1348ZM23.25 12.75H13.5V15c0-.0005 0 .0005 0 0-.0008.4135-.3363.75-.75.75a.7502.7502 0 0 1-.7379-.6152L12 15v-2.25H.75c.0005 0-.0005 0 0 0C.3365 12.7492 0 12.4137 0 12a.7502.7502 0 0 1 .6152-.7379L.75 11.25H12V9c0 .0005 0-.0005 0 0 .0008-.4136.3363-.75.75-.75a.7502.7502 0 0 1 .7379.6152L13.5 9v2.25h9.75c-.0005 0 .0005 0 0 0 .4135.0008.75.3363.75.75a.7502.7502 0 0 1-.6152.7379l-.1348.0121Z"
    clipRule="evenodd"
  />,
  'Customize'
);
